module.exports = __webpack_public_path__ + "static/img/bg_1.93b0b538.png";